import { inject, Injectable } from "@angular/core";
import { HelperService } from "./helper.service";
import { Observable } from "rxjs";
import { OnlineObjektSearchService } from "./online-objekt-search.service";
import { OfflineObjektSearchService } from "./offline-objekt-search.service";
import { ObjectData } from "./objekt-data.service";
import { ObjektModels } from "../models/objekt-models";


export interface SearchFilterOptions {
  readonly placesFilterOptions: Observable<ReadonlyArray<ObjektModels.ObjektOrt>>;
  readonly projectLeaderFilterOptions: Observable<ReadonlyArray<ObjektModels.Projektleiter>>;
  readonly statusFilterOptions: Observable<ReadonlyArray<ObjektModels.ObjektStatus>>;
}

export interface SearchParameters {
  searchTerm?: string;
  note4?: string;
  place?: { town: string }[];
  projectLeader?: { id: number }[];
  objStatus?: { id: number }[];
  useDynamicObjectSource?: boolean;
}

@Injectable({
  providedIn: "root",
})
export class ObjektSearchService {
  private readonly helperService = inject(HelperService);
  private readonly onlineSearchService = inject(OnlineObjektSearchService);
  private readonly offlineSearchService = inject(OfflineObjektSearchService);

  public getFilterOptions(): SearchFilterOptions {
    if (this.helperService.isWebServiceAvailable()) {
      return this.onlineSearchService.getFilterValues();
    } else {
      return this.offlineSearchService.getFilterValues();
    }
  }

  public search(searchParameters: SearchParameters): Observable<ObjectData[]> {
    if (this.helperService.isWebServiceAvailable()) {
      return this.onlineSearchService.search(searchParameters);
    } else {
      return this.offlineSearchService.search(searchParameters);
    }
  }
}
